'use client'

import { useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import Link from 'next/link'
import { MarketingChrome, BRAND } from '@/components/marketing/MarketingChrome'

export default function SupportShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const router = useRouter()

  useEffect(() => {
    if (window.self !== window.top) {
      const embedded = '/app-embed-shopify/support' + pathname.replace(/^\/support/, '')
      router.replace(embedded)
    }
  }, [pathname, router])

  return (
    <MarketingChrome active="support">
      {children}
    </MarketingChrome>
  )
}

export function SupportCTA() {
  return (
    <div style={{
      marginTop: 48,
      background: BRAND.ink,
      color: '#fff',
      padding: 'clamp(28px, 4vw, 40px)',
      borderRadius: 20,
    }}>
      <span className="saas-eyebrow" style={{ color: BRAND.gold }}>Another question?</span>
      <h3 className="font-display" style={{
        fontWeight: 700,
        fontSize: 'clamp(26px, 3vw, 36px)',
        lineHeight: 1.05,
        color: '#fff',
        marginTop: 14, marginBottom: 14,
      }}>
        Read before you ask?
      </h3>
      <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, marginBottom: 24, maxWidth: 480 }}>
        The docs cover most first-time questions — editor, widget, conditional layers, orders, billing. A lot of answers are a scroll away.
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Link href="/docs" className="btn-coral">
          Read the docs
          <span style={{ marginLeft: 4 }}>→</span>
        </Link>
        <a href="mailto:support@yespersonalized.com" style={{
          fontFamily: "'IBM Plex Sans', sans-serif",
          fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.75)',
        }}>
          support@yespersonalized.com
        </a>
      </div>
    </div>
  )
}
